export default __webpack_public_path__ + "static/media/dr-divyashree.d51f5a9b.png";